"use client";

import { useEffect } from "react";

export default function PreventSwipeNavigation() {
  useEffect(() => {
    // Добавляем стили для предотвращения свайпа навигации
    const style = document.createElement("style");
    style.textContent = `
      html, body {
        overscroll-behavior-x: none;
        touch-action: pan-y;
      }
    `;
    document.head.appendChild(style);

    // Дополнительная защита через обработчики событий
    let touchStartX = 0;
    let touchEndX = 0;

    const handleTouchStart = (e: TouchEvent) => {
      touchStartX = e.changedTouches[0].screenX;
    };

    const handleTouchMove = (e: TouchEvent) => {
      touchEndX = e.changedTouches[0].screenX;
      // Предотвращаем навигацию при горизонтальном свайпе от края экрана
      if (
        (touchStartX < 10 && touchEndX > touchStartX) ||
        (touchStartX > window.innerWidth - 10 && touchEndX < touchStartX)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("touchstart", handleTouchStart, { passive: true });
    document.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  return null;
}

